module.exports = __webpack_public_path__ + "static/market_share-73399babc9923803248009d72ba2bc18.png";